import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  brandVoiceSegment: {
    display: 'flex',
    flexDirection: 'column',
  },
  brandPersonalityTextarea: {
    background: 'salmon',
    width: '100%',
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    paddingBottom: '6px',
    paddingTop: '6px',
    ...shorthands.overflow('hidden'),
    '& textarea': {
      minHeight: '100px',
    },
  },
  brandToneInput: {
    maxWidth: '400px',
  },
  brandToneCaption: {
    marginTop: tokens.spacingVerticalXS,
  },
  brandPersonalityTagGroup: {
    marginBottom: tokens.spacingVerticalMNudge,
  },
  brandToneAccordion: {
    marginTop: tokens.spacingVerticalMNudge,
  },
});
